<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'text',
    },
    rows: {
      type: String,
      default: '5',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxlength: {
      type: Number,
      required: false,
      default: 0,
    },
    classStyle: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  data: function() {
    return {
      DEFAULT_STYLE: 'default',
      FULL_STYLE: 'full',
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value),
      }
    },
    attributes() {
      const attributes = {}
      if (this.maxlength > 0) {
        attributes.maxlength = this.maxlength
      }
      return attributes
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <textarea
      :value="value"
      :rows="rows"
      :placeholder="placeholder"
      v-bind="attributes"
      :class="[{ [$style.textareaDefault]: classStyle === DEFAULT_STYLE }, { [$style.textareaFull]: classStyle === FULL_STYLE }, $style.textarea]"
      @input="$emit('input', $event.target.value)"
      v-on="listeners"
    />
    <p
      v-if="maxlength"
      :class="[{ [$style.charsDefault]: classStyle === DEFAULT_STYLE }, { [$style.charsFull]: classStyle === FULL_STYLE }, $style.chars]"
    >{{ $t('MAXLENGTH_MESSAGE') }}: {{ maxlength }}</p>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  width: 100%;
  text-align: center;
}

.textarea {
  @extend %typography-medium;

  padding: 0.8rem 0.5rem 0.8rem 0.5rem;
  background-color: $white;
  border: 1px solid $divider-gray;
  border-radius: 8px;

  &Default {
    width: 95%;
  }

  &Full {
    width: 100%;
  }
}

textarea::-webkit-input-placeholder {
  color: $blue-gray;
}

textarea:focus {
  outline: none !important;
}

.chars {
  font-weight: bold;
  text-align: right;
  font-size: 12px;
  &Default {
    width: 95%;
  }

  &Full {
    width: 100%;
  }
}
</style>
